"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "app-container" };
const CustomTitle_vue_1 = __importDefault(require("../../../components/frontend/CustomTitle.vue"));
const ProgressBar_vue_1 = __importDefault(require("./ProgressBar.vue"));
const CarDatas_vue_1 = __importDefault(require("./CarDatas.vue"));
const Services_vue_1 = __importDefault(require("./Services.vue"));
const TireDetails_vue_1 = __importDefault(require("./TireDetails.vue"));
const TyreFitting_vue_1 = __importDefault(require("./TyreFitting.vue"));
const Calendar_vue_1 = __importDefault(require("./Calendar.vue"));
const Contact_vue_1 = __importDefault(require("./Contact.vue"));
const bookAppointmentStore_1 = require("../../../stores/bookAppointment/bookAppointmentStore");
const TimeZoneStore_1 = require("../../../stores/timeZone/TimeZoneStore");
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Reservation',
    setup(__props) {
        //import Navbar from "../../../components/Layout/FrontendNavbar.vue";
        const showLocations = (0, vue_3.ref)(false);
        const showTyreDatas = (0, vue_3.ref)(false);
        const showServices = (0, vue_3.ref)(false);
        const showAppintmentDate = (0, vue_3.ref)(false);
        const showContactInformation = (0, vue_3.ref)(false);
        const progressCounter = (0, vue_3.ref)(1);
        const bookAppointmentStore = (0, bookAppointmentStore_1.useBookAppointmentStore)();
        const timeZoneStore = (0, TimeZoneStore_1.useTimeZoneStore)();
        timeZoneStore.getTimeZone();
        /*
        watch([bookAppointmentStore.carDatas.licencePlate], ([newLicensePlate]) => {
          console.log(newLicensePlate);
        });*/
        (0, vue_3.watch)(() => [
            bookAppointmentStore.carDatas.licencePlate,
            bookAppointmentStore.carDatas.carBrand,
            bookAppointmentStore.carDatas.carEngine,
            bookAppointmentStore.carDatas.carModel,
            bookAppointmentStore.carDatas.carYearOfProduction,
            bookAppointmentStore.tyreDatas.tyreDiameter,
        ], ([newLicensePlate, newCarBand, newCarEngine, newCarModel, newCarYear, newTyreDiameter,]) => {
            if (newLicensePlate &&
                newCarBand &&
                newCarEngine &&
                newCarModel &&
                newCarYear &&
                newTyreDiameter) {
                //bookAppointmentStore.reservedServiceLocationId = 0;
                showLocations.value = true;
                progressCounter.value = 2;
                setTimeout(function () {
                    const element = document.querySelector("#locations");
                    if (element !== null) {
                        element.scrollIntoView({ behavior: "smooth" });
                    }
                }, 400, this);
            }
        });
        (0, vue_3.watch)(() => [bookAppointmentStore.reservedServiceLocationId], ([locationId]) => {
            if (locationId) {
                showTyreDatas.value = true;
                progressCounter.value = 3;
                setTimeout(function () {
                    const element = document.querySelector("#tyreDatas");
                    if (element !== null) {
                        element.scrollIntoView({ behavior: "smooth" });
                    }
                }, 400, this);
            }
            else {
                //showLocations.value = false;
                showTyreDatas.value = false;
                showServices.value = false;
                showAppintmentDate.value = false;
                showContactInformation.value = false;
            }
        });
        (0, vue_3.watch)(() => [bookAppointmentStore.tyreDatas.isWheel], ([isWheel]) => {
            if (isWheel !== null) {
                showServices.value = true;
                progressCounter.value = 4;
            }
        });
        (0, vue_3.watch)(() => [bookAppointmentStore.tyreFittingServiceSKU], ([sku]) => {
            if (sku !== null) {
                showAppintmentDate.value = true;
                progressCounter.value = 5;
                setTimeout(function () {
                    const element = document.querySelector("#calendar");
                    if (element !== null) {
                        element.scrollIntoView({ behavior: "smooth" });
                    }
                }, 400, this);
            }
            else {
                showAppintmentDate.value = false;
            }
        });
        (0, vue_3.watch)(() => [bookAppointmentStore.bookDate, bookAppointmentStore.bookTime], ([newBookDate, newBookTime]) => {
            if (newBookDate && newBookTime) {
                showContactInformation.value = true;
                progressCounter.value = 6;
                setTimeout(function () {
                    const element = document.querySelector("#contactInformations");
                    if (element !== null) {
                        element.scrollIntoView({ behavior: "smooth" });
                    }
                }, 400, this);
            }
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createVNode)(ProgressBar_vue_1.default, { step: progressCounter.value }, null, 8, ["step"]),
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    true
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(CustomTitle_vue_1.default, {
                            key: 0,
                            text: _ctx.$trans('car_datas', 'Car datas', 'frontend_reservation'),
                            icon: "auto_adatok.png"
                        }, null, 8, ["text"]))
                        : (0, vue_2.createCommentVNode)("", true),
                    true
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(CarDatas_vue_1.default, { key: 1 }))
                        : (0, vue_2.createCommentVNode)("", true),
                    (showLocations.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(CustomTitle_vue_1.default, {
                            key: 2,
                            id: "locations",
                            text: _ctx.$trans('location', 'Location', 'frontend_reservation'),
                            icon: "szerviz.png"
                        }, null, 8, ["text"]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (showLocations.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Services_vue_1.default, { key: 3 }))
                        : (0, vue_2.createCommentVNode)("", true),
                    (showTyreDatas.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(CustomTitle_vue_1.default, {
                            key: 4,
                            id: "tyreDatas",
                            text: _ctx.$trans('tyre_datas', 'Tyre datas', 'frontend_reservation'),
                            icon: "abroncs_adatok.png"
                        }, null, 8, ["text"]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (showTyreDatas.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(TireDetails_vue_1.default, { key: 5 }))
                        : (0, vue_2.createCommentVNode)("", true),
                    (showServices.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(CustomTitle_vue_1.default, {
                            key: 6,
                            text: _ctx.$trans('service', 'Service', 'frontend_reservation'),
                            icon: "szolgaltatas.png"
                        }, null, 8, ["text"]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (showServices.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(TyreFitting_vue_1.default, { key: 7 }))
                        : (0, vue_2.createCommentVNode)("", true),
                    (showAppintmentDate.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(CustomTitle_vue_1.default, {
                            key: 8,
                            id: "calendar",
                            text: _ctx.$trans('appointment', 'Appointment', 'frontend_reservation'),
                            icon: "idopont.png"
                        }, null, 8, ["text"]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (showAppintmentDate.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Calendar_vue_1.default, {
                            key: 9,
                            "time-zone-setting": (0, vue_2.unref)(timeZoneStore).timeZone
                        }, null, 8, ["time-zone-setting"]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (showContactInformation.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(CustomTitle_vue_1.default, {
                            key: 10,
                            id: "contactInformations",
                            text: _ctx.$trans('contact', 'Contact', 'frontend_reservation'),
                            icon: "elerhetoseg.png"
                        }, null, 8, ["text"]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (showContactInformation.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Contact_vue_1.default, { key: 11 }))
                        : (0, vue_2.createCommentVNode)("", true)
                ])
            ], 64));
        };
    }
});
